import React from "react";
import PropTypes from "prop-types";
import {
  Modal,
  Button,
  FormGroup,
  FormLabel,
  FormControl,
} from "react-bootstrap";
import { format } from "d3-format";
import { timeFormat } from "d3-time-format";

import { ChartCanvas, Chart } from "react-stockcharts";
import { BarSeries, RenkoSeries } from "react-stockcharts/lib/series";
import { XAxis, YAxis } from "react-stockcharts/lib/axes";
import {
  CrossHairCursor,
  EdgeIndicator,
  MouseCoordinateX,
  MouseCoordinateY,
} from "react-stockcharts/lib/coordinates";
import { saveInteractiveNodes, getInteractiveNodes } from "./interactiveutils";
import { discontinuousTimeScaleProvider } from "react-stockcharts/lib/scale";
import { OHLCTooltip, HoverTooltip } from "react-stockcharts/lib/tooltip";
import { renko, ema } from "react-stockcharts/lib/indicator";
import { last, head, toObject } from "react-stockcharts/lib/utils";
import {
  InteractiveText,
} from "react-stockcharts/lib/interactive";
import { getMorePropsForChart } from "react-stockcharts/lib/interactive/utils";
const dateFormat = (date) => {
  const adjustedDate = new Date(date.getTime() - 330 * 60000); // Subtract 330 minutes
  return timeFormat("%d-%m-%y %H:%M:%S")(adjustedDate);
};


class Dialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.text,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      text: nextProps.text,
    });
  }
  handleChange(e) {
    this.setState({
      text: e.target.value,
    });
  }
  handleSave() {
    this.props.onSave(this.state.text, this.props.chartId);
  }
  render() {
    const { showModal, onClose } = this.props;
    const { text } = this.state;

    return (
      <Modal show={showModal}
        onHide={onClose} animation={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit text</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <form>
            <FormGroup controlId="text">
              <FormLabel>Text</FormLabel>
              <FormControl
                type="text"
                value={text}
                onChange={this.handleChange}
              />
            </FormGroup>
          </form>
        </Modal.Body>

        <Modal.Footer>
          <Button bsStyle="primary" onClick={this.handleSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

class VewRenkoChart extends React.Component {
  // Tooltip content must always return an object with a content array
  constructor(props) {
    super(props);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.onDrawComplete = this.onDrawComplete.bind(this);
    this.handleChoosePosition = this.handleChoosePosition.bind(this);

    this.saveInteractiveNodes = saveInteractiveNodes.bind(this);
    this.getInteractiveNodes = getInteractiveNodes.bind(this);

    this.handleSelection = this.handleSelection.bind(this);

    this.saveCanvasNode = this.saveCanvasNode.bind(this);

    this.handleDialogClose = this.handleDialogClose.bind(this);
    this.handleTextChange = this.handleTextChange.bind(this);

    this.state = {
      enableInteractiveObject: true,
      textList_1: [],
      textList_3: [],
      showModal: false,
    };
  }
  saveCanvasNode(node) {
    this.canvasNode = node;
  }



  handleSelection = (interactives, moreProps, e) => {
    console.log("Inside handle selection", e);

    // Store moreProps for later use
    this.setState({ storedMoreProps: moreProps });

    if (this.state.enableInteractiveObject) {
      const independentCharts = moreProps.currentCharts.filter((d) => d !== 2);
      if (independentCharts.length > 0) {
        const first = head(independentCharts);
        const morePropsForChart = getMorePropsForChart(moreProps, first);
        const {
          mouseXY: [, mouseY],
          chartConfig: { yScale },
          xAccessor,
          currentItem,
        } = morePropsForChart;

        const position = [xAccessor(currentItem), yScale.invert(mouseY)];
        const newText = {
          ...InteractiveText.defaultProps.defaultText,
          position,
        };

        this.handleChoosePosition(newText, morePropsForChart, e);
      }
    } else {
      const state = toObject(interactives, (each) => {
        return [`textList_${each.chartId}`, each.objects];
      });
      this.setState(state);
    }
  };


  handleChoosePosition(text, moreProps) {
    const { id: chartId } = moreProps.chartConfig;
    console.log("Inside handle choose", chartId);
    this.setState(
      {
        [`textList_${chartId}`]: [
          ...this.state[`textList_${chartId}`],
          text
        ],
        showModal: true,
        text: text.text,
        chartId
      },
      () => {
        // This callback runs after the state is updated
        console.log("State after setting true", this.state);
      }
    );
  }


  handleTextChange(text, chartId) {
    this.setState(
      (prevState) => {
        const textList = prevState[`textList_${chartId}`] || [];
        if (textList.length === 0) return {}; // Prevents updating if there's no text box

        const updatedTextList = [...textList];
        updatedTextList[updatedTextList.length - 1] = { ...updatedTextList[updatedTextList.length - 1], text };

        return {
          [`textList_${chartId}`]: updatedTextList,
          showModal: false,
          enableInteractiveObject: false,
        };
      },
      () => {
        localStorage.setItem(`textList_${chartId}`, JSON.stringify(this.state[`textList_${chartId}`]));
      }
    );
  }

  handleDialogClose() {
    this.setState({
      showModal: false,
    });
    this.componentDidMount();
  }

  componentDidMount() {
    document.addEventListener("keyup", this.onKeyPress);
    const savedTextList_1 = JSON.parse(localStorage.getItem("textList_1")) || [];
    const savedTextList_3 = JSON.parse(localStorage.getItem("textList_3")) || [];

    this.setState({
      textList_1: savedTextList_1,
      textList_3: savedTextList_3,
    });
  }
  componentWillUnmount() {
    document.removeEventListener("keyup", this.onKeyPress);
  }


  onDrawComplete(textList, moreProps) {
    const { id: chartId } = moreProps.chartConfig;

    this.setState(
      {
        enableInteractiveObject: false,
        [`textList_${chartId}`]: textList,
      },
      () => {
        // Save the updated textList to localStorage
        localStorage.setItem(`textList_${chartId}`, JSON.stringify(textList));
      }
    );
  }

  onKeyPress(e) {
    const keyCode = e.which;
    console.log(keyCode);
    switch (keyCode) {
      case 46: {
        // DEL
        const updatedTextList_1 = this.state.textList_1.filter((d) => !d.selected);
        const updatedTextList_3 = this.state.textList_3.filter((d) => !d.selected);
        this.setState(
          {
            textList_1: updatedTextList_1,
            textList_3: updatedTextList_3,
          },
          () => {
            // Save updated text lists to localStorage
            localStorage.setItem("textList_1", JSON.stringify(updatedTextList_1));
            localStorage.setItem("textList_3", JSON.stringify(updatedTextList_3));
          }
        );
        break;
      }
      case 27: {
        // ESC
        this.setState({
          enableInteractiveObject: true,
        });
        break;
      }
      case 68: // D - Draw drawing object
      case 69: // E - Enable drawing object
      default: // default case 
    }
  }
  render() {
    const ema20 = ema()
      .id(0)
      .options({ windowSize: 20 })
      .merge((d, c) => {
        d.ema20 = c;
      })
      .accessor((d) => d.ema20);

    const ema50 = ema()
      .id(2)
      .options({ windowSize: 50 })
      .merge((d, c) => {
        d.ema50 = c;
      })
      .accessor((d) => d.ema50);

    const { type, data: initialData, width, ratio } = this.props;
    // console.log("initaildata", initialData);
    const renkoCalculator = renko()
      .options({
        reversalType: this.props.reversalType,
        fixedBrickSize: parseFloat(this.props.BrickSize >= 1 ? (this.props.BrickSize < 500 ? this.props.BrickSize : 100) : 1),
        sourcePath: this.props.sourcePath,
      });

    const calculatedData = renkoCalculator(initialData);

    const processedData = calculatedData.map(d => ({
      ...d,
      fill: d.close > d.open ? "#00C853" : "#D50000"  // Green for up, Red for down
    }));

    // console.log("Processed Data with Colors:", processedData);

    // console.log("Renko Data befor color processing:", calculatedData);

    const lastBrick = calculatedData[calculatedData.length - 1];
    const secondLastBrick = calculatedData.length > 1 ? calculatedData[calculatedData.length - 2] : null;

    // console.log("lastBrick", lastBrick);
    // console.log("secondLastBrick", secondLastBrick);


    const isBrickCompleted = Math.abs(lastBrick.close - lastBrick.open) >= this.props.BrickSize;

    const edgeIndicatorPrice = isBrickCompleted ? lastBrick.close : secondLastBrick?.close || lastBrick.close;

    // console.log("edgeIndicatorPrice", edgeIndicatorPrice);


    const xScaleProvider = discontinuousTimeScaleProvider.inputDateAccessor((d) => d.date);





    const {
      data,
      xScale,
      xAccessor,
      displayXAccessor,
    } = xScaleProvider(calculatedData);

    const start = xAccessor(last(data)) + 2;


    const end = xAccessor(data[Math.max(0, data.length - 150)]);
    const xExtents = [start, end];

    function tooltipContent(ys) {

      return ({ currentItem, xAccessor }) => {
        // console.log("Current item for date",currentItem);
        const selectedData = initialData[currentItem.from] || {};
        const decision = selectedData.RDecision_final || ""; // Default to "NOTRADE" if not found

        const decisionColors = {
          BUYYES: "green",
          SELLYES: "red",
          HOLD: "orange",
          NOTRADE: "gray",
          EXIT: "blue",
        };
        return {
          x: dateFormat(xAccessor(currentItem)),
          y: [
            {
              label: "Decision",
              value: decision,
              stroke: decisionColors[decision] || "black",
            },

          ]
            .concat(
              ys.map((each) => ({
                label: each.label,
                value: each.value(currentItem),
                stroke: each.stroke,
              }))
            )
            .filter((line) => line.value),
        };
      };
    }

    return (
      <div>
        

        <ChartCanvas
          ref={this.saveCanvasNode}
          height={470}
          ratio={ratio}
          width={width}
          margin={{ left: 80, right: 80, top: 10, bottom: 30 }}
          type="svg"
          seriesName="MSFT"
          data={data}
          xScale={xScale}
          xAccessor={xAccessor}
          displayXAccessor={displayXAccessor}
          xExtents={xExtents}
        >
          <Chart
            id={1}
            yExtents={(d) => [d.high, d.low]}
            padding={{ top: 10, bottom: 20 }}
          >
            <XAxis axisAt="bottom" orient="bottom" />
            <YAxis axisAt="right" orient="right" ticks={5} />


            {!isBrickCompleted &&
              <EdgeIndicator itemType="last" orient="right" edgeAt="right"
                yAccessor={() => lastBrick.close} fill={ema20.fill()} rectWidth={70}
                rectHeight={15} />
            }


            <EdgeIndicator itemType="last" orient="right" edgeAt="right"
              yAccessor={() => edgeIndicatorPrice} fill={d => d.close > d.open ? "#6BA583" : "#FF0000"} rectWidth={70} rectHeight={15} />

            <MouseCoordinateY
              at="right"
              orient="right"
              displayFormat={format(".2f")}
              rectWidth={70}
            />

            <RenkoSeries
              fill={{
                up: "#089981",
                down: "#f23645",
                partial: "#FFCF50",
              }}
            />

            <OHLCTooltip origin={[-40, 0]} />

            
            {/* HoverTooltip from lib/tooltip */}
            <HoverTooltip
              yAccessor={ema50.accessor()}
              tooltipContent={tooltipContent([

              ])}
              fontSize={15}
            />
          </Chart>

          <Chart
            id={2}
            yExtents={(d) => d.volume}
            height={150}
            origin={(w, h) => [0, h - 150]}
          >
            <YAxis
              axisAt="left"
              orient="left"
              ticks={5}
              tickFormat={format(".2s")}
            />
            <MouseCoordinateX
              at="bottom"
              orient="bottom"
              displayFormat={(date) => {
                let istDate = new Date(date);
                istDate.setMinutes(istDate.getMinutes() - 330); // Convert UTC to IST
                return timeFormat("%d-%m-%Y %H:%M")(istDate);
              }}
              rectWidth={120}
            />
            <MouseCoordinateY
              at="left"
              orient="left"
              displayFormat={format(".4s")}
            />
            <BarSeries
              yAccessor={(d) => d.volume}
              fill={(d) => (d.close > d.open ? "#6BA583" : "#FF0000")}
            />
          </Chart>

          <CrossHairCursor />

          
        </ChartCanvas>
        <Dialog
          showModal={this.state.showModal}
          text={this.state.text}
          chartId={this.state.chartId}
          onClose={this.handleDialogClose}
          onSave={this.handleTextChange}
        />
      </div>
    );
  }
}

VewRenkoChart.propTypes = {
  data: PropTypes.array.isRequired,
  width: PropTypes.number.isRequired,
  ratio: PropTypes.number.isRequired,
  type: PropTypes.oneOf(["svg", "hybrid"]).isRequired,
};



// VewRenkoChart = fitWidth(VewRenkoChart);

export default VewRenkoChart;





